<template>
  <div class="pardiv">
    <v-dialog persistent width="512px" :value="showNeedCalendarAuthDialog">
      <VCard class="dialog-card tw-pb-6">
        <v-btn
          absolute
          icon
          x-small
          class="dialog-close"
          @click="$emit('close')"
        >
          <v-icon size="18" color="grayLight">mdi-close</v-icon></v-btn
        >
        <img
          class="dialog-logo"
          src="../../../assets/img/hirefly-circle-logo.svg"
          alt="hirefly-logo"
        />
        <v-card-title class="card-title">
          <div class="title">Changes Needed!</div>
        </v-card-title>
        <v-card-text class="card-text">
          <p>
            The person who is set to interview candidates has not synced their
            calendar with our systems.
          </p>
          <p>
            Until
            {{ name }} syncs their calendar, you will be unable to approve
            candidates for interview.
          </p>
          <p>
            You can also update your project settings to use a different
            interview scheduling method in "Scheduling Preferences", after which
            you can proceed with approving candidates.
          </p>
          <p>
            If the interviewer has recently updated their permissions, or if you
            have recently changed project settings, please refresh the page to
            continue.
          </p>
        </v-card-text>
        <div class="dialog-buttons">
          <v-btn
            text
            color="primary"
            class="go-to-settings"
            @click="$emit('close')"
          >
            Ok
          </v-btn>
        </div>
      </VCard>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    showNeedCalendarAuthDialog: Boolean,
    projectSettings: Object,
  },

  computed: {
    name() {
      if (!this.projectSettings.warmleads_roles) return 'your interviewer';
      return (
        this.projectSettings.warmleads_roles.phone_screener_name ||
        'your interviewer'
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables.scss';
.title {
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0.71px;
  color: $gray-dark;
}
.dialog-card {
  width: 514px;
}
.card-title,
.card-text {
  justify-content: center;
  position: relative;
  text-align: center;

  .title {
    margin-bottom: 0;
  }
}

.card-title {
  margin-bottom: 0;
}

.card-text {
  font-size: 14px;
  font-weight: 400;
  padding-bottom: 0px !important;
  p {
    color: #111827;
    margin-bottom: 8px;
  }
}

.dialog-logo {
  margin-left: auto;
  margin-right: auto;
  display: block;
  padding-top: 16px;
}
.dialog-buttons {
  display: flex;
}
.go-to-settings {
  margin-top: 16px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-color: #c9c9c9;
  border: 1px solid;
}
.dialog-close {
  top: 3px;
  right: 5px;
}
</style>
